import { render, staticRenderFns } from "./MenuEditor.vue?vue&type=template&id=1542d7f4&scoped=true"
import script from "./MenuEditor.vue?vue&type=script&lang=js"
export * from "./MenuEditor.vue?vue&type=script&lang=js"
import style0 from "./MenuEditor.vue?vue&type=style&index=0&id=1542d7f4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1542d7f4",
  null
  
)

export default component.exports